import React from 'react'
import { SvgIcon, Typography, Stack } from '@mui/material'
import { ReactComponent as ArrowDownIcon } from '../../../../assets/images/arrows/down.svg'

export const ExpandButton: React.FC<{
    isExpanded: boolean
    onToggle: () => void
    totalCount: number
    visibleCount: number
}> = ({ isExpanded, onToggle, totalCount, visibleCount }) => (
    <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
        <Typography
            variant="16x600"
            color="figma.primary"
            sx={{
                textTransform: 'uppercase',
            }}
        >
            {`${visibleCount}/${totalCount}`}
        </Typography>

        <Stack
            direction="row"
            alignItems="center"
            width="max-content"
            gap={1}
            color="figma.primary"
            sx={{
                cursor: 'pointer',
                svg: {
                    pointerEvents: 'none',
                },
                userSelect: 'none',
                '&:hover': { opacity: 0.8 },
            }}
            onClick={onToggle}
        >
            <Typography color="inherit" variant="16x600" sx={{ textTransform: 'uppercase' }}>
                {isExpanded ? 'Close' : 'Show All'}
            </Typography>
            <SvgIcon
                component={ArrowDownIcon}
                inheritViewBox
                color="inherit"
                sx={{ fontSize: '16px', transform: isExpanded ? 'rotate(180deg)' : '' }}
            />
        </Stack>
    </Stack>
)
